import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import './assets/index.css'
import './services/firebase'
import store from "./store";
import can from './directives/can'
import i18n, { syncI18nLocale } from './i18n'

const app = createApp(App);
app.directive('can', can)
app.use(store);
app.use(i18n);

syncI18nLocale(store.state.locale || 'en');

store.subscribe((mutation) => {
  if (mutation.type === 'setLocale') {
    syncI18nLocale(mutation.payload);
  }
});

app.use(router);
app.mount('#app')
